import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import {
  changeColumnsMail,
  changeColumnsManager,
  changeColumnsManagerColaborators,
  changeColumnsManagerOperators,
  changeColumnsManagerGroupRow,
} from "../../actions";
import { useDispatch } from "react-redux";
import { Popover as Tippy, Tooltippy } from "../../actions/Tippy";
import { ReactComponent as SearchIcon } from "../../build/images/icons/searchmail.svg";
import "./popovercolumnsfilter.css";
import { changeColumnsDealing } from "../../actions/dealingNPS";
import { changeColumnsDealingAgent } from "../../actions/dealingQualityAgent";
import { saveColumnsNegotaitionsQualityAgent } from "../../actions/saveColumnsNegotaitionsQualityAgent";
import { changeCardsCallCenter } from "../../actions/changeCardsCallCenter";
import { changeCardsIndicatorsCallCenter } from "../../actions/changeCardsIndicatorsCallCenter";
import { reduceString } from "../../utils/reduceString";
import { changeCardsQuality } from "../../actions/changeCardsQuality";
import { changeCardsIndicatorsQuality } from "../../actions/changeCardsIndicatorsQuality";
import { changeCardsComparisonsQuality } from "../../actions/changeCardsComparisonsQuality";

export default function PopoverColumnsFilter({
  className,
  children,
  zIndex = 10,
  menuData = [
    {
      title: "Coluna1",
      exhib: true,
      filterDisplay: true,
    },
    {
      title: "Coluna2",
      exhib: false,
      filterDisplay: true,
    },
  ],
  setChangesActive,
  theme = "popover-default",
  maxWidth = "none",
  delay = [0, 0],
  trigger = "click",
  placement = "bottom",
  interactive = true,
  bind,
  screen,
  isReduceStringActive = false,
  headerText = "",
  ...rest
}) {
  //GENERAL

  //STATES
  const [columns, setColumns] = useState(menuData);
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();

  const hasHeaderText = !!headerText;

  //REDUX - Selectors

  //FUNCTIONS
  const handleChange = (idInput) => {
    const changeValue = [...columns.map((column) => ({ ...column }))];

    let columnExib = changeValue.find((value) => value.title === idInput);
    columnExib.exhib = !columnExib.exhib;

    setColumns(changeValue);

    if (screen === "manager") {
      dispatch(
        changeColumnsManager(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
          changeValue[10].exhib,
        ),
      );
      let storage = {
        service: changeValue[0].exhib,
        channels: changeValue[1].exhib,
        performed: changeValue[2].exhib,
        attended: changeValue[3].exhib,
        tma: changeValue[4].exhib,
        queue: changeValue[5].exhib,
        tme: changeValue[6].exhib,
        abandoned: changeValue[7].exhib,
        tm_a: changeValue[8].exhib,
        transfered: changeValue[9].exhib,
        tmr: changeValue[10].exhib,
      };
      localStorage.setItem("filters_manager_columns", JSON.stringify(storage));
    } else if (screen === "manager_colaborators") {
      dispatch(
        changeColumnsManagerColaborators(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
          changeValue[10].exhib,
          changeValue[11].exhib,
          changeValue[12].exhib,
          changeValue[13].exhib,
          changeValue[14].exhib,
          changeValue[15].exhib,
        ),
      );
      let storage = {
        attendants: changeValue[0].exhib,
        channels: changeValue[1].exhib,
        future: changeValue[2].exhib,
        status: changeValue[3].exhib,
        group: changeValue[4].exhib,
        tmr_email: changeValue[5].exhib,
        nps: changeValue[6].exhib,
        csat: changeValue[7].exhib,
        reason: changeValue[8].exhib,
        gda: changeValue[9].exhib,
        in: changeValue[10].exhib,
        tmain: changeValue[11].exhib,
        out: changeValue[12].exhib,
        tmaout: changeValue[13].exhib,
        timepausefuture: changeValue[14].exhib,
        timestatus: changeValue[15].exhib,
      };
      localStorage.setItem(
        "filters_manager_columns_colaborators",
        JSON.stringify(storage),
      );
    } else if (screen === "manager_operators") {
      dispatch(changeColumnsManagerOperators(changeValue));
      localStorage.setItem(
        "filters_manager_columns_operators",
        JSON.stringify(changeValue),
      );
    } else if (screen === "manager_groupRow") {
      dispatch(changeColumnsManagerGroupRow(changeValue));
      localStorage.setItem(
        "filters_manager_columns_groupRow",
        JSON.stringify(changeValue),
      );
    } else if (screen === "nps_dealing") {
      dispatch(
        changeColumnsDealing(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
        ),
      );
      let storage = {
        unit: changeValue[0].exhib,
        attendance: changeValue[1].exhib,
        client: changeValue[2].exhib,
        ratedIn: changeValue[3].exhib,
        response: changeValue[4].exhib,
        profile: changeValue[5].exhib,
        note: changeValue[6].exhib,
        os: changeValue[7].exhib,
        attendant: changeValue[8].exhib,
        status: changeValue[9].exhib,
      };
      localStorage.setItem(
        "filters_nps_dealing_columns",
        JSON.stringify(storage),
      );
    } else if (screen === "quality_agent_dealing") {
      dispatch(
        changeColumnsDealingAgent(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
          changeValue[10].exhib,
          changeValue[11].exhib,
        ),
      );

      let storage = {
        avaliation: changeValue[0].exhib,
        service: changeValue[1].exhib,
        attendance: changeValue[2].exhib,
        response: changeValue[3].exhib,
        profile: changeValue[4].exhib,
        note: changeValue[5].exhib,
        attendant: changeValue[6].exhib,
        group: changeValue[7].exhib,
        attendantQuality: changeValue[8].exhib,
        contact: changeValue[9].exhib,
        channel: changeValue[10].exhib,
        status: changeValue[11].exhib,
      };

      localStorage.setItem(
        "filters_quality_agent_dealing_columns",
        JSON.stringify(storage),
      );
    } else if (screen === "quality_agent_negotiations") {
      dispatch(
        saveColumnsNegotaitionsQualityAgent({
          name: changeValue[0].exhib,
          nps: changeValue[1].exhib,
          csat: changeValue[2].exhib,
        }),
      );

      let storage = {
        name: changeValue[0].exhib,
        nps: changeValue[1].exhib,
        csat: changeValue[2].exhib,
      };

      localStorage.setItem(
        "filters_quality_agent_negotiations_columns",
        JSON.stringify(storage),
      );
    } else if (screen === "dash-call-center") {
      dispatch(
        changeCardsCallCenter(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
          changeValue[10].exhib,
          changeValue[11].exhib,
          changeValue[12].exhib,
        ),
      );

      const storage = {
        card1: changeValue[0].exhib,
        card2: changeValue[1].exhib,
        card3: changeValue[2].exhib,
        card4: changeValue[3].exhib,
        card5: changeValue[4].exhib,
        card6: changeValue[5].exhib,
        card7: changeValue[6].exhib,
        card8: changeValue[7].exhib,
        card9: changeValue[8].exhib,
        card10: changeValue[9].exhib,
        card11: changeValue[10].exhib,
        card12: changeValue[11].exhib,
        card13: changeValue[12].exhib,
      };

      localStorage.setItem("cards-dash-call-center", JSON.stringify(storage));
    } else if (screen === "indicators-call-center") {
      dispatch(
        changeCardsIndicatorsCallCenter(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
        ),
      );

      const storage = {
        card1: changeValue[0].exhib,
        card2: changeValue[1].exhib,
        card3: changeValue[2].exhib,
        card4: changeValue[3].exhib,
        card5: changeValue[4].exhib,
        card6: changeValue[5].exhib,
        card7: changeValue[6].exhib,
      };

      localStorage.setItem(
        "cards-indicators-call-center",
        JSON.stringify(storage),
      );
    } else if (screen === "dash-quality") {
      dispatch(
        changeCardsQuality(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[6].exhib,
          changeValue[7].exhib,
          changeValue[8].exhib,
          changeValue[9].exhib,
          changeValue[10].exhib,
          changeValue[11].exhib,
          changeValue[12].exhib,
          changeValue[13].exhib,
          changeValue[14].exhib,
          changeValue[15].exhib,
        ),
      );

      const storage = {
        card1: changeValue[0].exhib,
        card2: changeValue[1].exhib,
        card3: changeValue[2].exhib,
        card4: changeValue[3].exhib,
        card5: changeValue[4].exhib,
        card6: changeValue[5].exhib,
        card7: changeValue[6].exhib,
        card8: changeValue[7].exhib,
        card9: changeValue[8].exhib,
        card10: changeValue[9].exhib,
        card11: changeValue[10].exhib,
        card12: changeValue[11].exhib,
        card13: changeValue[12].exhib,
        card14: changeValue[13].exhib,
        card15: changeValue[14].exhib,
        card16: changeValue[15].exhib,
      };

      localStorage.setItem("cards-dash-quality", JSON.stringify(storage));
    } else if (screen === "indicators-quality") {
      dispatch(
        changeCardsIndicatorsQuality(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
        ),
      );

      const storage = {
        card1: changeValue[0].exhib,
        card2: changeValue[1].exhib,
        card3: changeValue[2].exhib,
      };

      localStorage.setItem("cards-indicators-quality", JSON.stringify(storage));
    } else if (screen === "comparisons-quality") {
      dispatch(
        changeCardsComparisonsQuality(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[2].exhib,
          changeValue[3].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
        ),
      );

      const storage = {
        card1: changeValue[0].exhib,
        card2: changeValue[1].exhib,
        card3: changeValue[2].exhib,
        card4: changeValue[3].exhib,
        card5: changeValue[4].exhib,
        card6: changeValue[5].exhib,
      };

      localStorage.setItem(
        "cards-comparisons-quality",
        JSON.stringify(storage),
      );
    } else {
      dispatch(
        changeColumnsMail(
          changeValue[0].exhib,
          changeValue[1].exhib,
          changeValue[4].exhib,
          changeValue[5].exhib,
          changeValue[3].exhib,
          changeValue[2].exhib,
        ),
      );
    }
  };

  const handleChangeInput = (value) => {
    setInputValue(value);
  };

  const handleFilter = (value) => {
    if (inputValue) {
      if (value.title.toLowerCase().includes(inputValue.toLowerCase())) {
        return value;
      } else {
        return;
      }
    } else {
      return value;
    }
  };

  const renderContent = (data) => {
    return (
      <ul className="popover-columns-filter filters-columns">
        {hasHeaderText && (
          <h2 className="popover-columns-filter__header-text">{headerText}</h2>
        )}
        <div className="popover-columns-filter filters-columns__container">
          <div className="popover-columns-filter filters-columns__container-icon">
            <SearchIcon />
          </div>
          <input
            type="text"
            className="input-popover"
            onChange={(event) => handleChangeInput(event.target.value)}
            defaultValue={inputValue}
          />
        </div>

        <div className="popover-columns-filter__content">
          {data.filter(handleFilter).map((menu, key) => {
            return (
              <div key={key} className="columns-checkbox">
                <Switch
                  id={menu.title}
                  checked={menu.exhib}
                  onChange={() => handleChange(menu.title)}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor={"#b8c1ea"}
                  onHandleColor={"#455CC7"}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  width={34}
                  height={14}
                  handleDiameter={20}
                />
                {isReduceStringActive ? (
                  <label htmlFor={menu.title}>
                    <Tooltippy content={menu.title ? menu.title : ""}>
                      <span>{reduceString(menu.title, 16)}</span>
                    </Tooltippy>
                  </label>
                ) : (
                  <label htmlFor={menu.title}>
                    <span>{menu.title}</span>
                  </label>
                )}
              </div>
            );
          })}
        </div>
      </ul>
    );
  };

  //USE EFFECTS
  useEffect(() => {
    if (inputValue === "") {
      setColumns(menuData);
    }
  }, [inputValue, menuData]);

  return (
    <Tippy
      // theme={theme}
      // trigger={trigger}
      content={renderContent(columns)}
      placement="left"
      // delay={delay}
      // zIndex={zIndex}
      allowHTML
      // interactive={interactive}
      {...rest}
    >
      {children}
    </Tippy>
  );
}
